import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Global error handler to suppress non-critical errors from browser extensions
window.addEventListener('error', (event) => {
  // Suppress "No tab with id" errors (likely from browser extensions)
  if (event.message && event.message.includes('No tab with id')) {
    event.preventDefault();
    return false;
  }
});

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  // Suppress "No tab with id" errors in promises (likely from browser extensions)
  if (event.reason && typeof event.reason === 'object' && event.reason.message && event.reason.message.includes('No tab with id')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
